import { render, staticRenderFns } from "./substancepopup.vue?vue&type=template&id=138a05f7&scoped=true&"
import script from "./substancepopup.vue?vue&type=script&lang=js&"
export * from "./substancepopup.vue?vue&type=script&lang=js&"
import style0 from "./substancepopup.vue?vue&type=style&index=0&id=138a05f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a05f7",
  null
  
)

export default component.exports